module.exports = __webpack_public_path__ + "img/自动回复.d703ce70.png";